import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  requirementsMonitorsLength: 0,
  requirementsMonitors: [],
  requirementsMonitor: {},
  requirementsMonitorError: "",
  formError: "",
  requirementsUrls: false,
  loadingUrl: false,
  requirementsUrlsError: "",
  saveLoadingUrl: false,
  formUrlError: "",
};

export default function RequirementsMonitorReducer(
  state = initialData,
  action
) {
  switch (action.type) {
    case actions.LOADING_REQUIREMENTS_MONITOR:
      return { ...state, loading: action.payload };
    case actions.LOADING_REQUIREMENTS_MONITOR_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.LOADING_REQUIREMENTS_URL:
      return { ...state, loadingUrl: action.payload };

    case actions.SAVE_LOADING_REQUIREMENTS_MONITOR:
      return { ...state, saveLoading: action.payload };

    case actions.SAVE_LOADING_REQUIREMENTS_URL:
      return { ...state, saveLoadingUrl: action.payload };

    case actions.GET_REQUIREMENTS_MONITOR:
      return {
        ...state,
        requirementsMonitors: action.payload.requirementsMonitors,
        requirementsMonitorsLength: action.payload.requirementsMonitorsLength,
      };
    case actions.GET_REQUIREMENTS_MONITOR_BY_ID:
      return {
        ...state,
        requirementsMonitor: action.payload,
      };

    case actions.GET_REQUIREMENTS_URL:
      return { ...state, requirementsUrls: action.payload };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

      case actions.FORM_URL_FAIL:
        return { ...state, formUrlError: action.payload };

    case actions.REQUIREMENTS_MONITOR_FAIL:
      return { ...state, requirementsMonitorError: action.payload };

    case actions.REQUIREMENTS_URL_FAIL:
      return { ...state, requirementsUrlsError: action.payload };

    default:
      return state;
  }
}
